/* eslint-disable no-unused-vars */
import { useState } from 'react';
import Ic from '../Icon';

const VENDORS = [
  // HVAC
  { id:1, name:'AirPro DFW',           cat:'HVAC',        ph:'214-555-0110', area:'Dallas / Fort Worth', rating:4.8, reviews:127, note:'24/7 emergency service, free estimates' },
  { id:2, name:'Cool Breeze HVAC',     cat:'HVAC',        ph:'817-555-0220', area:'Fort Worth / Tarrant', rating:4.6, reviews:84,  note:'Specializes in older systems, senior discount' },
  // Plumbing
  { id:3, name:'FlowMaster Plumbing',  cat:'Plumbing',    ph:'972-555-0330', area:'Plano / Frisco / McKinney', rating:4.9, reviews:203, note:'Same-day service, licensed & insured' },
  { id:4, name:'DFW Rooter & Drain',   cat:'Plumbing',    ph:'469-555-0440', area:'All DFW Metro', rating:4.5, reviews:61,  note:'Drain clearing, leak detection, re-pipe' },
  // Electrical
  { id:5, name:'Lone Star Electric',   cat:'Electrical',  ph:'214-555-0550', area:'Dallas / Garland / Mesquite', rating:4.7, reviews:155, note:'Panel upgrades, EV charger install, rewiring' },
  { id:6, name:'Volt Pro Services',    cat:'Electrical',  ph:'817-555-0660', area:'Fort Worth / Arlington', rating:4.4, reviews:42,  note:'Residential & commercial, code compliance' },
  // Landscaping
  { id:7, name:'Green Acres Lawn',     cat:'Landscaping', ph:'972-555-0770', area:'Collin County & North Dallas', rating:4.6, reviews:98,  note:'Weekly/bi-weekly, irrigation systems' },
  { id:8, name:'Texas Turf Pros',      cat:'Landscaping', ph:'214-555-0880', area:'All DFW Metro', rating:4.3, reviews:74,  note:'Seasonal cleanup, tree trimming, mulching' },
  // Painting
  { id:9, name:'Premier Coat Painters',cat:'Painting',    ph:'469-555-0990', area:'DFW Metro', rating:4.8, reviews:66,  note:'Interior/exterior, turnover specials for landlords' },
  { id:10,name:'Brush & Roll DFW',     cat:'Painting',    ph:'972-555-1010', area:'North Dallas / Frisco', rating:4.5, reviews:31,  note:'Fast turnovers, cabinet refinishing' },
  // Flooring
  { id:11,name:'Floors By Design',     cat:'Flooring',    ph:'214-555-1120', area:'Dallas Metro', rating:4.7, reviews:88,  note:'Hardwood, LVP, tile, carpet — install & repair' },
  { id:12,name:'DFW Floor Depot',      cat:'Flooring',    ph:'817-555-1230', area:'Fort Worth / Grand Prairie', rating:4.4, reviews:53,  note:'Budget-friendly, quick installs' },
  // Roofing
  { id:13,name:'Apex Roofing DFW',     cat:'Roofing',     ph:'972-555-1340', area:'All DFW Metro', rating:4.9, reviews:174, note:'Insurance claims, storm damage, free inspection' },
  { id:14,name:'Summit Roofing Co',    cat:'Roofing',     ph:'214-555-1450', area:'Dallas / Rockwall / Rowlett', rating:4.6, reviews:91,  note:'Shingle, metal, flat roofs' },
  // General Handyman
  { id:15,name:'Fix-It-All DFW',       cat:'Handyman',    ph:'469-555-1560', area:'All DFW Metro', rating:4.7, reviews:215, note:'No job too small, drywall, doors, fixtures' },
  { id:16,name:'Handyman Hub',         cat:'Handyman',    ph:'817-555-1670', area:'Fort Worth / Burleson / Mansfield', rating:4.5, reviews:103, note:'Same-day availability, flat-rate pricing' },
  // Pest Control
  { id:17,name:'Terminix DFW',         cat:'Pest Control',ph:'214-555-1780', area:'All DFW Metro', rating:4.6, reviews:320, note:'Quarterly plans, termite warranty' },
  { id:18,name:'ProShield Pest',       cat:'Pest Control',ph:'972-555-1890', area:'Plano / Allen / Richardson', rating:4.8, reviews:77,  note:'Family-safe treatments, same-week service' },
];

const CATEGORIES = ['All', ...new Set(VENDORS.map(v => v.cat))];

const CAT_ICONS = {
  HVAC: 'tool', Plumbing: 'tool', Electrical: 'shield', Landscaping: 'star',
  Painting: 'edit', Flooring: 'build', Roofing: 'build', Handyman: 'tool', 'Pest Control': 'alert',
};
const CAT_COLORS = {
  HVAC: '#f97316', Plumbing: '#58a6ff', Electrical: '#d29922', Landscaping: '#22c55e',
  Painting: '#c084fc', Flooring: '#fb7185', Roofing: '#94a3b8', Handyman: '#4ade80', 'Pest Control': '#f85149',
};

function Stars({ rating }) {
  return (
    <span style={{display:'inline-flex',alignItems:'center',gap:3}}>
      <Ic n="star" s={11} c="#d29922"/>
      <span style={{fontSize:11,fontWeight:700,color:'#d29922'}}>{rating.toFixed(1)}</span>
    </span>
  );
}

export default function VendorDirectory() {
  const [cat, setCat]     = useState('All');
  const [search, setSearch] = useState('');

  const visible = VENDORS.filter(v => {
    if (cat !== 'All' && v.cat !== cat) return false;
    if (search && !v.name.toLowerCase().includes(search.toLowerCase()) &&
        !v.cat.toLowerCase().includes(search.toLowerCase()) &&
        !v.area.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  return (
    <div>
      {/* Header */}
      <div className="card" style={{marginBottom:16,background:'linear-gradient(135deg,rgba(22,163,74,.12),rgba(74,222,128,.05))'}}>
        <div style={{display:'flex',alignItems:'center',gap:12}}>
          <div style={{width:44,height:44,background:'linear-gradient(135deg,#16a34a,#4ade80)',borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center'}}>
            <Ic n="users" s={20} c="#0a1a0a"/>
          </div>
          <div>
            <div style={{fontFamily:"'Playfair Display',serif",fontSize:17,fontWeight:900,color:'#fff'}}>DFW Vendor Network</div>
            <div style={{fontSize:12,color:'#8b949e',marginTop:2}}>Trusted service providers in the Dallas-Fort Worth area — vetted for landlord use</div>
          </div>
          <div style={{marginLeft:'auto',textAlign:'right'}}>
            <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:900,color:'#4ade80'}}>{VENDORS.length}</div>
            <div style={{fontSize:10,color:'#484f58',textTransform:'uppercase',letterSpacing:1}}>Vendors</div>
          </div>
        </div>
      </div>

      {/* Search */}
      <input
        className="srch"
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder="Search vendors, categories, or service areas..."
      />

      {/* Category tabs */}
      <div className="tabs" style={{flexWrap:'wrap'}}>
        {CATEGORIES.map(c => (
          <button key={c} className={`tab${cat===c?' tab-on':''}`} onClick={() => setCat(c)}>
            {c}
          </button>
        ))}
      </div>

      {/* Vendor grid */}
      {visible.length === 0 ? (
        <div className="card" style={{textAlign:'center',padding:'40px',color:'#484f58'}}>
          <Ic n="users" s={36} c="#484f58"/>
          <div style={{marginTop:12,fontSize:13}}>No vendors match your search</div>
        </div>
      ) : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))',gap:12}}>
          {visible.map(v => (
            <div key={v.id} className="card" style={{marginBottom:0,position:'relative',overflow:'hidden'}}>
              <div style={{
                position:'absolute',top:0,left:0,right:0,height:3,
                background:`linear-gradient(90deg,${CAT_COLORS[v.cat]||'#4ade80'},transparent)`,
              }}/>
              <div style={{display:'flex',alignItems:'flex-start',gap:12,marginBottom:10}}>
                <div style={{
                  width:40,height:40,borderRadius:10,flexShrink:0,
                  background:`rgba(${hexToRgb(CAT_COLORS[v.cat]||'#4ade80')}, 0.15)`,
                  display:'flex',alignItems:'center',justifyContent:'center',
                }}>
                  <Ic n={CAT_ICONS[v.cat]||'tool'} s={18} c={CAT_COLORS[v.cat]||'#4ade80'}/>
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,color:'#fff',fontSize:13,lineHeight:1.3}}>{v.name}</div>
                  <div style={{display:'flex',alignItems:'center',gap:6,marginTop:3}}>
                    <span style={{
                      fontSize:10,fontWeight:700,padding:'1px 8px',borderRadius:20,
                      background:`rgba(${hexToRgb(CAT_COLORS[v.cat]||'#4ade80')}, 0.15)`,
                      color: CAT_COLORS[v.cat]||'#4ade80',
                    }}>{v.cat}</span>
                    <Stars rating={v.rating}/>
                    <span style={{fontSize:10,color:'#484f58'}}>({v.reviews})</span>
                  </div>
                </div>
              </div>

              <div style={{fontSize:11,color:'#8b949e',marginBottom:8,display:'flex',alignItems:'center',gap:5}}>
                <Ic n="home" s={10} c="#484f58"/>
                {v.area}
              </div>

              {v.note && (
                <div style={{fontSize:11,color:'#6b7280',marginBottom:12,fontStyle:'italic',lineHeight:1.4}}>
                  {v.note}
                </div>
              )}

              <div style={{display:'flex',gap:8,alignItems:'center'}}>
                <a
                  href={`tel:${v.ph}`}
                  className="btn btn-g"
                  style={{flex:1,justifyContent:'center',padding:'7px 12px',fontSize:11,textDecoration:'none'}}
                >
                  <Ic n="phone" s={12}/> {v.ph}
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function hexToRgb(hex) {
  const m = hex.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
  return m ? `${parseInt(m[1],16)},${parseInt(m[2],16)},${parseInt(m[3],16)}` : '74,222,128';
}
